import { useEffect, useMemo, useState } from 'react'
import { Table, Space, Button, Form, Input, Modal } from 'antd'
import TextArea from "antd/lib/input/TextArea"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout } from '../../js/globalParam'
import _ from 'lodash'

const { Column } = Table

type pagination = {
    current: number,
    pageSize: number,
    total: number
}

type fetchParams = {
    type_name: string | undefined,
}

const initForm = {
    type_name: undefined,
    remark: undefined
}

export default function MaterialType() {

    let paginatioTml = {
        current: 1,
        pageSize: 8,
        total: 0
    }

    let otherParamsTml = {
        type_name: undefined
    }

    const [pagination, setPagination] = useState<pagination>(paginatioTml)
    const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)
    const [tableList, setTableList] = useState<any[]>([])

    const [form] = Form.useForm()
    const [addVisible, setAddVisible] = useState<boolean>(false)
    const [recordID, setRecordID] = useState<string | undefined>(undefined)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, otherParams })
    }, [pagination.current])

    const handleInputChange = (value: string, attr: string) => {
        let params: any = _.cloneDeep(otherParams)
        params[attr] = value

        setOtherParams(params)
    }

    const handleSearch = () => {
        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, otherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...otherParams }

        axiosTable.get('/yuezi_center/material_type/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setTableList(response.records)
            }
        })
    }

    const resetForm = () => {
        setOtherParams(otherParamsTml)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, otherParams: otherParamsTml })
    }

    const onFinish = (values: any) => {
        let url = recordID ? '/yuezi_center/material_type/update' : '/yuezi_center/material_type/add'

        if (recordID) {
            values.id = recordID
        }

        baseAxiosComplete.post(url, {
            ...values

        }).then(res => {
            if (res.status === 0) {
                setAddVisible(false)
                form.setFieldsValue(initForm)

                resetForm()
            }
        })
    }

    return (<div className="common-page">
        {/* 月子中心 -> 月子配置管理 -> 物料分类管理 */}
        <BreadCrumb position={['月子中心', '物料分类管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="分类名称" value={otherParams.type_name} onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'type_name') }} />

                {permission.includes('查询') && <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 5, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
                {permission.includes('添加') && <Button style={{ marginRight: 5, marginBottom: 12 }} type="primary" onClick={() => {
                    form.setFieldsValue(initForm)

                    setRecordID(undefined)
                    setAddVisible(true)
                }}>添加</Button>}
            </Space>
        </div>

        <div className="common-main">
            <Table dataSource={tableList} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="分类名称" dataIndex="type_name" key="type_name" />
                <Column title="备注" dataIndex="remark" key="remark" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {permission.includes('编辑') && <Button type="primary" onClick={() => {
                                form.setFieldsValue({
                                    "type_name": record.type_name,
                                    "remark": record.remark
                                })

                                setRecordID(record.id)
                                setAddVisible(true)
                            }}>编辑</Button>}
                        </Space>)
                    }}
                />
            </Table>
        </div>

        {/* 月子中心 -> 月子配置管理 -> 物料分类管理 -> 新增或编辑 */}
        <Modal title={recordID ? "编辑物料分类" : "新增物料分类"} visible={addVisible} onCancel={() => { setAddVisible(false) }} footer={false} width="450px">
            <Form {...formItemLayout} name="validate_other" form={form} onFinish={onFinish}>
                <Form.Item required label="分类名称" name="type_name" rules={[{ required: true, message: '必须填写分类名称' }]} >
                    <Input placeholder="请输入分类名称" />
                </Form.Item>

                <Form.Item label="备注" name="remark" >
                    <TextArea style={{ height: 100 }} />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}